import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
 @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
  alertMessage = { alertClass: 'success', message: 'Some Message' }
  constructor() { }

  success(message: any) {
    this.eventEmitter.emit({ alertClass: 'alert-success', message: message });
  }
  info(message: any) {
    this.eventEmitter.emit({ alertClass: 'alert-info', message: message });
  }
  warning(message: any) {
    this.eventEmitter.emit({ alertClass: 'alert-warning', message: message });
  }
  danger(message: any) {
    this.eventEmitter.emit({ alertClass: 'alert-danger', message: message });
  }

  getEventEmitter() {
    return this.eventEmitter;
  }
}
